import React from 'react';
import styles from '../styles/ShakeDropdown.module.scss';
import { useShake } from '../ShakeProvider';

export default function ShakeDropdown() {
  const { templates, loading, isDropdownOpen, setDropdownOpen, openForTemplate } = useShake();

  if (!isDropdownOpen) return null;

  return (
    <div className={styles.menu} role="menu" aria-label="Shake templates">
      <div className={styles.header}>Templates</div>
      {loading && <div className={styles.empty}>Loading…</div>}
      {!loading && templates.length === 0 && <div className={styles.empty}>No templates</div>}
      {!loading &&
        templates.map((tpl) => (
          <div
            key={tpl.id}
            className={styles.item}
            role="menuitem"
            onClick={() => {
              setDropdownOpen(false);
              openForTemplate(tpl.id);
            }}
          >
            {tpl.name}
          </div>
        ))}
    </div>
  );
}
